import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster, toast, resolveValue } from 'react-hot-toast'
import App from './App.jsx'
import './styles/globals.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster
          position="bottom-right"
          containerStyle={{ bottom: 24, right: 24 }}
          gutter={10}
          toastOptions={{
            duration: 4000,
            className: '',
            style: {
              maxWidth: 380,
              padding: '12px 14px',
              borderRadius: '14px',
              fontSize: '13.5px',
              fontWeight: 500,
              boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
            },
            success: {
              duration: 3500,
              style: {
                background: '#f0fdf4',
                color: '#15803d',
                border: '1px solid #bbf7d0',
              },
              iconTheme: { primary: '#16a34a', secondary: '#f0fdf4' },
            },
            error: {
              duration: 6000,
              style: {
                background: '#fef2f2',
                color: '#b91c1c',
                border: '1px solid #fecaca',
              },
              iconTheme: { primary: '#ef4444', secondary: '#fef2f2' },
            },
            loading: {
              style: {
                background: '#eff6ff',
                color: '#1d4ed8',
                border: '1px solid #bfdbfe',
              },
              iconTheme: { primary: '#3b82f6', secondary: '#eff6ff' },
            },
          }}
        >
          {(t) => (
            <div
              style={{
                display: 'flex', alignItems: 'center', gap: 10,
                maxWidth: 380, width: '100%',
                padding: '11px 14px',
                borderRadius: 14,
                fontSize: '13.5px', fontWeight: 500,
                boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
                opacity: t.visible ? 1 : 0,
                transition: 'opacity 0.2s',
                background: t.type === 'success' ? '#f0fdf4'
                  : t.type === 'error'   ? '#fef2f2'
                  : t.type === 'loading' ? '#eff6ff'
                  : '#1e293b',
                color: t.type === 'success' ? '#15803d'
                  : t.type === 'error'   ? '#b91c1c'
                  : t.type === 'loading' ? '#1d4ed8'
                  : '#f1f5f9',
                border: `1px solid ${
                  t.type === 'success' ? '#bbf7d0'
                  : t.type === 'error'   ? '#fecaca'
                  : t.type === 'loading' ? '#bfdbfe'
                  : '#334155'
                }`,
              }}
            >
              <span style={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>
                {t.type === 'success' ? '✓'
                  : t.type === 'error' ? '✕'
                  : t.type === 'loading' ? '⟳'
                  : 'ℹ'}
              </span>
              <span style={{ flex: 1, lineHeight: 1.4 }}>
                {resolveValue(t.message, t)}
              </span>
              <button onClick={() => toast.dismiss(t.id)}
                style={{
                  flexShrink: 0, background: 'none', border: 'none', cursor: 'pointer',
                  padding: '2px 4px', borderRadius: 6, opacity: 0.6,
                  color: 'inherit', fontSize: 15, lineHeight: 1,
                }}
                onMouseEnter={e => e.target.style.opacity = 1}
                onMouseLeave={e => e.target.style.opacity = 0.6}
              >
                ✕
              </button>
            </div>
          )}
        </Toaster>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
